export default __webpack_public_path__ + "assets/8ab6f151f61d2786f929864fa69919d0.png";